import { reactive } from "vue";

export const usersState = reactive({
  selectedUser: null,
});
